<!--
 * @Author: lbb lhz6887@163.com
 * @Date: 2024-07-04 09:07:32
 * @LastEditors: lbb lhz6887@163.com
 * @LastEditTime: 2024-07-19 11:26:48
 * @FilePath: \YHB_H5\src\pages\oneClickRegister\uploadImg.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <van-uploader :after-read="upload" accept="image/*" >
        <img v-if="img" class="img" :src="img" mode="scaleToFill" :style="{ width: width, height: height }" />
        <div v-else class="img" :style="{ backgroundImage: `url(${bgImg})`, width: width, height: height }"></div>
        <div class="identifying">{{ txt }}</div>
    </van-uploader>
</template>

<script>
import { Toast } from 'vant';
import { h5upload } from "@/api/index"
import { compressorImage } from "@/utils/core.js"
export default {
    name: 'UPloadImg',
    props: {
        img: {
            type: String,
            default: ''
        },
        bgImg: {
            type: String,
            default: ''
        },
        txt: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: '110px'
        },
        height: {
            type: String,
            default: '70px'
        },
    },
    data() {
        return {

        };
    },
    created() {

    },
    methods: {
        async upload(file, val) {
            Toast.loading({
                message: '上传中...',
                forbidClick: true,
                duration: "toast"
            });
            // 压缩 
            const fileData = await compressorImage(file.file, "file", 0.5)
            let formData = new FormData();
            formData.append("file", fileData);
            h5upload(formData).then(res => {
                if (res.code != 200) {
                    Toast.clear()
                    this.$toast("上传失败")
                    return
                }
                this.$emit("upload", { url: res.data.url, type: this.type })
            })
        }
    },
};
</script>

<style scoped lang="scss">
.img {
    // width: 110px;
    // height: 70px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 12px;
}

.identifying {
    // width: 110px;
    margin-top: 5px;
    text-align: center;
    font-size: 12px;
    color: #999999;

}
</style>
